export default {
  virtual_games: "Trò chơi ảo",
  bet_limit: "Giới hạn cược",
  favorites: "Ưa thích",
  note: "Ghi chú",
  my_bets: "Cược của tôi",
  my_account: "Tài khoản của tôi",
  contact_us: "Liên hệ chúng tôi",
  report: "Báo biểu",
  help_support: "Hỗ trợ và giúp đỡ",
  currency: "Tiền Tệ",
  others: "Khác",
  welcome: "Chào mừng",
  account_id: "Tài khoản nhận dạng",
  password: "Mật khẩu",
  account: "Tài khoản",
  all_sports: "Mọi môn thể thao",
  my_sports: "Thể Thao",
  action: "Thao tác",
  accept_better_odds: "Tự nhận tỷ lệ cược tốt",
  accept_any_odds: "Chấp nhận bất cứ tỷ giá nào",
  auto_refresh_odds: "Tự động làm mới tỷ giá",
  auto_refresh: "Tự làm mới",
  auto_refreshing: "Đang tự động làm mới...",
  all_markets: "Toàn bộ thị trường",

  away: "Khách",

  all: "Toàn bộ",
  accepted: "Đã chấp nhận",
  add_to_parlay: "Thêm vào xiên",
  add_to_booster: "Add To Booster",
  amount: "số tiền",
  amount_before_balance: "Số tiền trước khi kết toán",
  amount_after_balance: "Số tiền sau khi kết toàn",

  bet_slip: "Bảng cược mini",
  bet_credit: "Tín dụng cược",
  bet_list: "Danh sách cược",
  betting: "Đặt cược",
  balance: "Số dư",

  betting_statement: "Tình trạng đặt cược",
  bet_types: "Dạng đặt cược",
  bet_type: "Dạng đặt cược",
  bs: "B/S",
  bet_summary: "Tổng hợp cược",
  bet_reject: "Mã cược vô hiệu",
  bets: "Các mã cược",
  bet: "Mã cược",
  booster: "Boost",

  casino: "Sòng bạc",
  mini_casino: "Sòng bạc nhỏ",
  cash_balance: "Số dư tiền mặt",
  change_account_password: "Thay đổi mật khẩu tài khoản",
  current_password: "Mật khẩu hiện tại",
  confirm_new_password: "Xác nhận mật khẩu mới",
  customize_sports_order: "Tuỳ chỉnh thứ tự thể thao",
  choice: "Lựa chọn",
  credit: "Tín dụng",
  commission: "Hoa hồng",
  customize: "Tuỳ chỉnh",
  cancel: "Hủy",
  confirmation: "Xác nhận",
  closing_balance: "Số dư cuối kỳ",
  clear_filter: "Làm mới bộ lộc",

  debit: "Ghi nợ",
  display_language: "Ngôn ngữ hiển thị",
  default_event_sorting: "Mặc định sắp xếp sự kiện",
  default_stake: "Cược mặc định",
  date: "Ngày",
  draw: " Hòa",
  draw_cancel: " Hòa",
  dec: "DEC",
  double_line: "Hiện thị 2 dòng",
  disable: "Vô hiệu hoá",
  dec_odds: "Tỷ giá thập phân",
  id_odds: "Tỷ giá Indo",
  double_chance: "Nhân đôi cơ hội",

  enable: "Kích hoạt",
  event_sorting: "Sắp xếp sự kiện",
  // esports: "Thể thao điện tử",
  // esports2: "Thể thao điện tử",
  // e_sports: "Thể thao điện tử",
  edit: "Thiết lập",
  early: "Sớm",
  event: "Sự kiện",
  even: "Chẵn",

  first_goal: "Bàn thắng đầu",
  first_half: "Hiệp đầu",
  final: "Kết",
  full_time: "Cả trận",
  first_5_inn: "5 lượt đầu tiên",

  games: "Trò chơi",
  given_credit: "thêm tín dụng",
  group: "Nhóm",
  goal: "Bàn thắng",

  half_time: "Hiệp 1",
  hide_header: "Ẩn tiêu đề",
  hk: "Hồng Kông",
  hk_odds: "Tỷ giá Hồng Kông",
  home: "Chủ nhà",

  id: "Xác thực",
  inactive: "Không hoạt động",
  inplay: "Đang chơi",

  keno: "Trò chơi số",
  kickoff: "Phát bóng",

  lottery: "Xổ số",
  login: "Đăng nhập",
  logout: "Đăng xuất",
  last_login: "Lần đăng nhập cuối cùng",
  last_transaction: "Lần giao dịch cuối cùng",
  live_streaming: "Đang trực tiếp",
  live_tv: "Đang trực tiếp",
  live_match: "Trận đang trực tiếp",
  live: "Trực tiếp",
  live_center: "Trung tâm trực tiếp",
  livecasino: "Sòng bạc trực tuyến",
  loss: "Thua",
  lost: "Mất",
  lose: "Mất",
  lose_half: "Thua nữa",
  last_bet: "Cược cuối",
  last_goal: "Bàn thắng cuối",

  mobile: "Điện thoại",
  message: "Tin nhắn",
  my_bet: "Cược của tôi",
  my_favorites: "Ưa thích của tôi",
  market_type: "Dạng thị trường",
  match: "Trận đấu",
  message_history: "Lịch sử tin nhắn",
  my: "Mã Lai",
  market: "Thị trường",
  main_markets: "Thị trường chính",
  my_odds: "Tỷ giá Mã Lai",
  min: "Thấp nhất",
  max: "Lớn nhất",
  max_payout: "Trả thưởng tối đa",
  main: "Chính",
  corners: "Phạt góc/Thẻ",
  specials: "Đặc biệt",
  mix_parlay: "Xiên hỗn hợp",
  moneyline: "Dòng tiền",

  no_goal: "Không có bàn thắng",
  normal_announcements: "Thông báo thường",
  nickname: "Biệt danh",
  new_password: "Mật khẩu mới",
  new: "Mới",
  "no/": "Thứ tự.",
  normal_sorting: "Sắp xếp bình thường",

  other_markets: "Các thị trường khác",
  outstanding: "Mã cược đang chạy",
  odds_type: "Dạng tỷ giá",
  odds: "Tỷ giá",
  opening_balance: "Tín dụng đầu",
  outright: "Vô địch",
  on: "Mở",
  off: "Đóng",
  outstanding_bet: "Mã cược đang chạy",
  over: "Tài",
  odd: "Tỷ giá",
  hdp: "Kèo chấp",
  ou: "Tài/Xỉu",
  oe: "Lẻ/Chẵn",
  oxt: "1X2",
  ml: "Dòng tiền",

  password_expiry: "Mật khẩu hết hạn",
  parlay: "Xiên",
  page_display: "Hiển thị trang",
  page_type: "Dạng trang",
  page_size: "Kích cỡ trang",
  personal_message: "Tin nhăn cá nhân",
  process_bet: "Đặt cược",
  payout: "Trả thưởng",
  pending: "Đang chờ xử lý",

  quick_bet: "Cược nhanh",
  quick_bet_stake: "Cược nhanh",

  result: "Kết quả",
  restore: "Phục hồi",
  remark: "Ghi chú",
  ref_no: "Thứ tự mã cược.",
  remove_from_parlay: "Gỡ xiên",
  remove_from_booster: "Remove Booster",
  running: "Đang Diễn Ram",
  rules: "Luật",
  rules_regulations: "Nội quy và Quy Định",

  sports: "Thể thao",
  show_balance: "Hiển thị số dư",
  statement: "Sao kê",
  settings: "Cài đặt",
  search_team: "Tìm kiếm đội",
  show_header: "Hiển thị tiêu đề",
  submit: "Chấp nhận",
  set_nickname: "Đặt biệt danh",
  single: "Đơn",
  save: "Lưu",
  show_score_map: "Hiển thị đồ thị điểm",
  stake: "cược",
  status: "Tình trạng",
  sort: "Sắp xếp",
  sportsbook: "Thể thao",
  sum: "Tổng",
  special_announcements: "Tin nhắn đặc biệt",
  subtotal: "Tổng",
  single_line: "Dòng đơn",
  sort_by_time: "Sắp xếp theo thời gian",
  slots: "máy xèng",
  mini_slots: "máy xèng",
  select_leagues: "lựa chọn giải đấu",
  settled_amount: "Tiền đã quyết toán",

  turnover: "Doanh số",
  today: "Hôm nay",
  time: "Thời gian",
  team: "Đội",
  to: "Đến",
  trans_time: "đổi thời gian",
  total: "tổng",
  total_goal: "tổng bàn thắng",
  treble: "Cú ăn ba",
  transaction_date: "Ngày giao dịch",
  transfer_method: "Phương thức chuyển tiền",
  transfer: "chuyển tiền",

  under: "Xỉu",
  void: "Hoàn lại",
  reject: "Loại bỏ",
  rejected: "Loại bỏ",
  valid_turnover: "Doanh số có hiệu lực",

  win: "Thắng",
  won: "Đã thắng",
  won_half: "Đã thắng 1 nữa",
  waiting: "Đang Chờ",

  yes: "Có",
  no: "không",

  yesterday: "Hôm qua",
  monday: "Thứ 2",
  tuesday: "Thứ 3",
  wednesday: "Thứ 4",
  thursday: "Thứ 5",
  friday: "Thứ 6",
  saturday: "Thứ 7",
  sunday: "Chủ nhật",

  all_league: "Toàn bộ",
  match_completed: "Đã hoàn tất",
  match_pending: "Kết quả chờ đợi",
  match_cancelled: "Hoàn trả",
  match_cancelled_1h: "Hoàn trả hiệp 1",
  match_cancelled_2h: "Hoàn trả hiệp 2",
  match_suspended: "Từ bỏ",
  match_suspended_1h: "Từ bỏ hiệp 1",
  match_suspended_2h: "Từ bỏ hiệp 2",

  check_all: "Kiểm tra toàn bộ",
  selected_only: "Chọn khu vực chỉ định",
  filtered: "Chọn lọc",
  turn_on: "Mở",
  turn_off: "Đóng",

  preference: "Ưu tiên của tôi",

  market_1: "Sớm",
  market_2: "Hôm nay",
  market_3: "Đang chạy",

  // RULES & REGULATION

  // asian_handicap: "Kèo chấp châu Á",
  // acceptance_countdown: "Chấp nhận thời gian đếm ngược",
  // acceptance_rules: "Chấp nhận quy tắc và quy định đặt cược",
  // application_betting_rule: "Chấp nhận Quy định đặt cược chung",
  // bettype_settlement_rule: "Quy tắc quyết toán các dạng mã cược",
  // change_schedule: "Thay đổi thời gian/ thời gian dự kiến",
  // change_venue: "Thay đổi địa điểm",
  // cons_interpret: "Xây dựng và giải thích",
  // definition_of_term: "Định nghĩa thuật ngữ",
  // general_betting_rule: "Luật đặt cược chung",
  // general_terms: "Điều khoản và điều kiện chung",
  // general_provision: "Các quy định chung",
  // general_rules_bt: "Quy tắc chung : thị trường",
  // handicaps: "Kèo chấp (HDP) & Kèo chấp hiệp 1 & kèo chấp hiệp 2",
  // running_bet_service: 'Dịch vụ mã cược đang chạy',
  // limitation_provision: "Giới hạn trách nhiệm và cung cấp bồi thường",
  // match_duration: "Thời lượng trận đấu / sự kiện",
  // member_account: "Tài khoản hội viên",
  // mixparlays: "Xiên hỗn hợp",
  // mixparlay_payout: "Xiên hỗn hợp : tôi đa trả thưởng",
  // over_unders: "Tài/Xiu (O/U) & Hiệp 1 Tài/Xỉu &Hiệp 2 Tài/Xỉu",
  // odd_evens: "Lẻ/Chẵn (OE) & Hiệp 1 Lẻ/Chẵn & Hiệp 2 Lẻ/Chẵn",
  // rules_governing: "Quy tắc quản lý các sự kiện chung & sự kiện đặc biệt",
  // results: "Kết quả",
  // software_game: "Phần mềm và trò chơi",
  // single_team_oe: "1 Đội Lẻ/Chẵn",
  // sport_betting_rule: "Luật đặt cược thể thao",
  // terms_of_transact: "Điều khoản giao dịch",
  // warranties: "Bảo hành và đại diện của thành viên",

  american_football: "Bóng đá Mỹ",
  soccer: "Bóng đá",
  basketball: "Bóng rổ",
  baseball: "Bóng chày",
  esports: "Thể thao điện tử",
  tennis: "Quần vợt",

  events: "sự kiện",

  first_digit: "1st Digit",
  second_digit: "2nd Digit",
  third_digit: "3rd Digit",
  forth_digit: "4th Digit",
  total_4d: "Total 4D",
  total_3d: "Total Last 3D",
  total_1st2d: "Total 1st 2D",
  total_last2d: "Total Last 2D",

  prize1: "1ST PRIZE",
  prize2: "2ND PRIZE",
  prize3: "3RD PRIZE",

  round1: "ROUND 1",
  round2: "ROUND 2",
  round3: "ROUND 3",
  round4: "ROUND 4",
  round5: "ROUND 5",

  map1: "MAP 1",
  map2: "MAP 2",
  map3: "MAP 3",
  map4: "MAP 4",
  map5: "MAP 5",
  map6: "MAP 6",
  map7: "MAP 7",
  map8: "MAP 8",
  map9: "MAP 9",
  map10: "MAP 10",

  mini_games: "những trò chơi nhỏ",

  sysparlay: "Cược xiên hệ thống",
  abets: " Đặt cược",
  afold: " Kết hợp",
  fold: " Kết hợp",

  continue: "Tiếp Tục",
  highlight: "Điểm nổi bật",
  show_all_time: "Hiển thị mọi lúc",
  back: "Trở lại",
  // fishing: "trò chơi câu cá",
  upnext: "Tiếp theo",
  no_video: "Không có video",
  mm_odds: "Xác suất myanmar",
  mmo_parlay: "Xiên myanmar",
  myanmar: "Myanmar",
  combo: "kết hợp",
  total_bet: "toàn bộ sách cược",
  total_stake: "Số tiền đặt cược",
  total_match: "Số lượng trò chơi",
  combination: "sự phối hợp",
  stakeperbet: "Tiền Cược Độc thân",
  total_payout: "Thanh Toán Tổng",
  total_accept: "Chấp nhận Tổng",
  total_reject: "từ chối Tổng ",
  sum_wl: "Tổng thắng thua",
  sum_bet: "Tổng cược",

  abandoned: "Bị bỏ rơi",
  score: "Ghi bàn",
  winner: "Người chiến thắng",

  upcoming: "Sắp tới",

  adjustment: "điều chỉnh",
  // poker: "bài xì phé"
};
